<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/frameworks/web-awesome']" appearance="plain" variant="neutral">&larr; Back to Web Awesome</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>WaAnimatedImage</h1>
		</div>
		<p waBody="m" waColorText="quiet" waText>Animated image &#40;GIF/APNG/WebP&#41; with play/pause controls</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_272" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</wa-details>
	</div>
</div>